import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Lightbulb, TrendingUp, Settings, BarChart3 } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';

const HowItWorksSection = () => {
  const { t } = useLanguage();

  const steps = [
    {
      icon: Settings,
      title: t('howItWorksStep1'),
      description: t('howItWorksStep1Desc'),
      color: 'from-[#00f4ff] to-[#12b7ff]'
    },
    {
      icon: BarChart3,
      title: t('howItWorksStep2'),
      description: t('howItWorksStep2Desc'),
      color: 'from-[#12b7ff] to-[#0677aa]'
    },
    {
      icon: TrendingUp,
      title: t('howItWorksStep3'),
      description: t('howItWorksStep3Desc'),
      color: 'from-[#0677aa] to-[#00f4ff]'
    },
    {
      icon: Lightbulb,
      title: t('howItWorksStep4'),
      description: t('howItWorksStep4Desc'),
      color: 'from-[#00f4ff] to-[#12b7ff]'
    }
  ];

  return (
    <Card className="mt-8">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-gradient-to-br from-[#0051ff]/15 to-[#00e5ff]/15 border border-[#00e5ff]/25">
            <Lightbulb className="w-6 h-6 text-[#00f4ff]" />
          </div>
          <CardTitle>{t('howItWorksTitle')}</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div 
                key={index}
                className="relative p-6 rounded-xl bg-gradient-to-br from-[#0b1c38]/50 to-[#040816]/50 border border-[#00f4ff]/10 hover:border-[#00f4ff]/30 transition-all duration-300 group"
              >
                <div className="flex items-start gap-4">
                  <div className={`p-3 rounded-lg bg-gradient-to-br ${step.color} shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <IconComponent className="w-5 h-5 text-[#040816]" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base font-bold text-white mb-2">
                      {step.title}
                    </h3>
                    <p className="text-sm text-[#9EB4C0] leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Disclaimer box */}
        <div className="mt-6 p-4 rounded-xl bg-gradient-to-r from-yellow-500/10 to-orange-500/10 border-2 border-yellow-500/30">
          <div className="flex items-start gap-3">
            <Lightbulb className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-[#9EB4C0] leading-relaxed">
              <span className="font-bold text-yellow-500">{t('eduBadge')}:</span>{' '}
              {t('howItWorksDisclaimer')}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default HowItWorksSection;
